<h2>
  {{'world_cup_ranking' | transloco}}: &nbsp;
  <span>{{
    $any(
    $any(filter_service.filtersType[2].options).options_selected_subject.asObservable()
    | async
    )?.name
    }}
    {{
    (
    filter_service.filtersType[1].options.options_selected_subject.asObservable()
    | async
    )?.name
    }}</span>
</h2>
<table class="wa-table">
  <thead class="wa-table__header-group">
    <tr class="wa-table__row">
      <th class="h-ranking sortable wa-table__cell" (click)="changeSort('RANKING')" [ngClass]="rankingSort()">
        <span>{{'Ranking' | transloco}}</span>
      </th>
      <th class="h-name sortable wa-table__cell" [ngClass]="sortClass('NAME')" (click)=" changeSort('NAME')">
        <span>
          {{
          $any(
          filter_service.filtersType[1].options.options_selected_subject.asObservable()
          | async
          )?.name === "Individual"
          ? ("Name" | transloco)
          : ("Team" | transloco)
          }}</span>
      </th>
      <th *ngIf="
          (
            filter_service.filtersType[1].options.options_selected_subject.asObservable()
            | async
          )?.name === 'Individual'
        "
        class="h-team sortable wa-table__cell" [ngClass]="sortClass('TEAM')" (click)="changeSort('TEAM')">
        <span>{{'Country' | transloco}}</span>
      </th>
      <th class="h-points sortable wa-table__cell" [ngClass]="sortClass('POINTS')" (click)="changeSort('POINTS')">
        <span>{{'Points' | transloco}}</span>
      </th>
    </tr>
  </thead>
  <ng-container>
    <tbody class="wa-table__row-group" *ngFor="let ranking of data" [Ranking]="ranking" app-wcup-rannking-item
      class="wa-table__row-group">
      <!--<app-wcup-rannking-item appRemoveTag class="wa-table__row-group"
  ></app-wcup-rannking-item>-->
    </tbody>
  </ng-container>
  <ng-template #noresults>
    <tbody class="wa-table__row-group">
      <div *ngIf="loading===false" class="status-message status-message--info">{{'no_results' | transloco}} {{defaultValueMessage|async|transloco}}</div>
    </tbody>
  </ng-template>

</table>
<app-load-more-button *ngIf="data!==undefined &&  data.length!==0; else noresults" (loadMore)="loadMore()" [loading]="loading" [areMoreData]="areMoreData()"></app-load-more-button>


